$(document).ready(function () {
  // Language selector
  let countrySelector = $('#country-selector');
  //get country data through api
  $.ajax({
    url: countrySelector.data('url'),
    dataType: 'json',
    success: function (data) {
      const country_list = data;

      // get current country info
      var current_country_lang_id = countrySelector.data('countryLanguageId'); //get current current_country_lang_id: UK = 5
      var current_country = countrySelector.data('country');
      var current_country_data = null;
      var country_by_id = {};
      // display all country list
      for (let region_idx in country_list) {
        //get Region name
        var region_name = country_list[region_idx].regionName;
        //display only 6 country each column
        var country_counter = 0;
        for (let country_id in country_list[region_idx].countries) {
          //get container
          var region_id = parseInt(region_idx) + 1;
          var $container = $('.countries__list').find('[data-id="' + region_id + '"]');
          for (let lang_id in country_list[region_idx].countries[country_id]) {
            var country_data = country_list[region_idx].countries[country_id][lang_id];
            country_by_id[country_data.countryLanguageId] = country_data;
            var $country_item = {
              link: $('<a />', { href: country_data.url, title: country_data.countryName }),
              wrapper: $('<div />', { class: 'country-wrapper d-flex' }),
              item: $('<div />', { class: 'country__item', html: `<span>${country_data.countryName}</span><br /><span>${country_data.language}</span>` }),
              flag: $('<div />', { class: 'country__flag', 'style': 'background-image: url(' + country_data.flag + ')' })
            };

            if (current_country_lang_id === country_data.countryLanguageId) {
              $country_item.wrapper.addClass('active');
            }

            $country_item.wrapper.append($country_item.flag);
            $country_item.wrapper.append($country_item.item);
            $country_item.link.append($country_item.wrapper);

            if (country_counter == 7 || country_counter == 0) {
              country_counter = 0;
              $container.append($('<div />', { class: 'country__col' }));
            }
            if (country_id === current_country) {
              current_country_data = country_data;
            }

            $container.find('.country__col:last-child').append($country_item.link);
            country_counter++;
          } // eof country_lang loop
        } // eof country loop
      } // eof region loop

      //append suggested country list - array
      var suggested_country_list = [];
      for (let ind in current_country_data.suggestedCountries) {
        var suggested_country_id = current_country_data.suggestedCountries[ind];
        var country_data = country_by_id[suggested_country_id];
        $country_item = {
          link: $('<a />', { href: country_data.url, title: country_data.countryName }),
          wrapper: $('<div />', { class: 'country-wrapper d-flex' }),
          item: $('<div />', { class: 'country__item', html: `<span>${country_data.countryName}</span><br /><span>${country_data.language}</span>` }),
          flag: $('<div />', { class: 'country__flag', 'style': 'background-image: url(' + country_data.flag + ')' })
        };
        $country_item.wrapper.append($country_item.flag);
        $country_item.wrapper.append($country_item.item);
        $country_item.link.append($country_item.wrapper);
        suggested_country_list.push($country_item.link);
      }
      if (suggested_country_list.length > 0) {
        for (let suggested_country in suggested_country_list) {
          $('.suggested-countries__list').append(suggested_country_list[suggested_country]);
        }
      } else {
        $('.suggested-countries').remove();
      }
    },
    statusCode: {
      404: function () {
        // 404 error
      }
    },
    error: function (err) {
      console.log(err);
    }
  }) // eof ajax
  }) 

 